module.exports = __webpack_public_path__ + "media/images/icons/flags/BQ-2-56a42c88f25a1a83479a7bb5a5a5729f.svg";